export default __webpack_public_path__ + "static/media/member-plus.84472a52.svg";